import { useEffect, useState, useRef } from 'react';
import '../assets/css/CustomUtility.css'; // This is having invalid feedback and Datepicker related css
import '../assets/css/feather.css';
import '../assets/css/CG.css';
import '../assets/css/Login.css';
import { GetPayLoad, RemovePayLoad } from '../services/PayLoadStorage';
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';
import { useLogoutContent } from '../contexts/LogoutContentContext';

const Logout = () => {
    const ref = useRef(null);
    // Announcement refs for 508 compliance
    const logoutAnnouncementRef = useRef(null);
    const [logoutMsg, setLogoutMsg] = useState([]);
    const [logoSrc, setLogoSrc] = useState('');
    const [imgSrc, setImgSrc] = useState('');
    const [logotitle, setLogoTitle] = useState(''); //st48236 - 508 compliance
    const {logoutContent} = useLogoutContent();// This is custom hook, this will fetch logout content messages
    
    //Check login type
    const loginFrom = sessionStorage.getItem('loginFrom') || null;
    const [ showSignInBtn, setShowSignInBtn] = useState(true);
    
    useEffect(() => {
        loadStyle();
        if (logoutContent?.logout) {
            setLogoutMsg(logoutContent.logout);
        }
        if(loginFrom === 'Carrier'){
            setShowSignInBtn(false); // Hide sign in button for carrier SSO users as they will use their own portal to login
        }

    }, [logoutContent, loginFrom]);

    //Focus on main element for accessibility (st48236 - 508 compliance)
    useEffect(() => {
        let timeoutId;
        timeoutId = setTimeout(() => {
            if (logoutAnnouncementRef.current) {
                logoutAnnouncementRef.current.textContent = logoutMsg?.logout_msg ?? 'You have successfully logged out from your system';
                logoutAnnouncementRef.current.textContent += " "; // Adding a pause for screen readers
                logoutAnnouncementRef.current.textContent += logoutMsg?.logout_logout_signin_btn ?? 'Click here to sign in';
                logoutAnnouncementRef.current.textContent += " button";
                logoutAnnouncementRef.current.setAttribute('aria-live', 'assertive');
            }
            if (ref.current) {
                ref.current.focus();
            }
        }, 500); // Delay to ensure DOM is ready
        
        return () => clearTimeout(timeoutId);
    }, [logoutMsg]);

    //Clear session if user lands on logout page
    useEffect(() => {
        setTimeout(() => {
            //User manually lands on logout page, clear payload if exists.
            if (GetPayLoad('PayLoad')) {
                RemovePayLoad('PayLoad');
            }
            localStorage.clear(); // Clear local storage
            sessionStorage.clear(); // Clear session storage
            clearAllCookies(); // Clear all cookies
            
        }, 1000); //Set timeout to ensure the page is content loaded before clearing session storage

    }, []);

    const excludeCookies = ['lang', 'owningCarrier', 'portal_lang']; // Always exclude these cookies
    if(Cookies.get('isConnectiCareCarrier') === 'true' && Cookies.get('connectiCareCarrier') !== null){
        excludeCookies.push('isConnectiCareCarrier', 'connectiCareCarrier');
    }
    const clearAllCookies = () => {
        const allCookies = Cookies.get(); // Get all cookies as an object
        const cookieOptions = getCookieOptions(); // Get environment-aware cookie options
        Object.keys(allCookies).forEach(cookieName => {
            if(!excludeCookies.includes(cookieName)) { // Exclude specific cookies
                Cookies.remove(cookieName, { ...cookieOptions, path: '/' });
            }
        });
    }

    //Navigate to login page after logout - redirect to base URL without carrier prefix
    const handleClickLogin = () => {
        const currentHost = window.location.hostname;
        
        // For localhost, just navigate to /SlpMember
        if (currentHost === 'localhost' || currentHost === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(currentHost)) {
            const port = window.location.port ? `:${window.location.port}` : '';
            window.location.href = `http://${currentHost}${port}/SlpMember`;
            return;
        }
        
        // Remove carrier prefix from hostname (e.g., dev-cigna-member.healthplan.com -> dev-member.healthplan.com)
        const baseHost = currentHost.replace(/^([^-]+)-(cigna|molina|bcbsaz|sentara|christus|hcsc|mhc)-member(\..+)$/i, '$1-member$3');
        const protocol = window.location.protocol;
        window.location.href = `${protocol}//${baseHost}/SlpMember`;
    }
    
    let actualCarrier = Cookies.get('owningCarrier');
    const isConnectiCareCarrier = Cookies.get('isConnectiCareCarrier') || 'false';
    const connectiCareCarrier = Cookies.get('connectiCareCarrier') || null;
    if(isConnectiCareCarrier === 'true' && connectiCareCarrier === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
        actualCarrier = connectiCareCarrier;
    }

    const loadStyle = async () => {

        import('../assets/images/carriers-logo/'+actualCarrier+'-sml.svg').then((image) => {
            setLogoSrc(image.default);
        });
        
        //Set Default image if specific carrier image not found
        import('../assets/images/Illustrations/Logout-'+actualCarrier+'.svg').then((image) => {
            setImgSrc(image.default);
        }).catch(() => {
            import('../assets/images/Illustrations/Logout.svg').then((image) => {
                setImgSrc(image.default);
            });
        });
        
        await import('../assets/css/'+actualCarrier+'.css');

        //st48236 - 508 compliance
        const owningCarrier = Cookies.get('owningCarrier') || 'CG';
        if(owningCarrier === 'CG'){
            setLogoTitle("Cigna Member Portal");
        }
        if(owningCarrier === 'M1'){
            setLogoTitle("MHC Member Portal");
        }
        if(owningCarrier === 'Q5'){
            setLogoTitle("BCBSAZ Member Portal");
        }
        if(owningCarrier === 'SY'){
            setLogoTitle("Sentara Member Portal");
        }
        if(owningCarrier === 'XC'){
            setLogoTitle("Christus Member Portal");
        }
        if(owningCarrier === 'C4'){
            setLogoTitle("Molina Member Portal");
        }
        if(owningCarrier === 'X6'){
            setLogoTitle("HCSC Member Portal");
        }
        if(actualCarrier === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
            setLogoTitle("ConnectiCare Member Portal");
        }
         //st48236 - 508 compliance
    };

    return (
        <div>
            {/* 508 compliance announcements - Hidden from view 
            <div ref={logoutAnnouncementRef} aria-live="assertive" role="status" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }} tabIndex={0}></div>*/}
            
            <section className="min-h-100 d-flex justify-content-center">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-xxl-11 px-0">
                            <div style={{ background: '#fff' }} className="border-light-subtle mb-0">
                                <div className="row g-0 shadow-lg">
                                    <div className="col-12 col-md-6 overlay-sl text-center pt-xl-3 p-3 
                                    p-sm-0 p-md-0 p-xl-0">
                                        <img src={imgSrc} alt="Payment-mobile" className="mw-90 mt-5 pb-4" />
                                    </div>
                                    <div className="col-12 col-md-6 d-flex mt-4 justify-content-center
                                    align-items-center">
                                        <div className="col-12 col-lg-11 col-xl-10">
                                            <div className="card-body p-3 p-md-4 p-xl-3" tabIndex="-1" ref={ref} aria-live="assertive" role="status"> {/*st48236 - 508 compliance*/}
                                                <div className="row">
                                                    <div className="col-12 d-flex">
                                                        <div className="col-6">
                                                            {logoSrc && (
                                                                <img src={logoSrc} className="mb-2" alt={logotitle || "Member Portal"}  />
                                                            )} {/*st48236 - 508 compliance*/}
                                                        </div>
                                                        <div className="col-6 text-end">
                                                        </div>
                                                    </div>
                                                </div>
                                                <form className="needs-validation" novalidate>
                                                    <div className="row gy-3 overflow-hidden mt-0">
                                                        <div className="member-SLP mt-4">
                                                            <h3 className="text-left fw-semibold primary-color mb-3 pb-2">
                                                                {logoutMsg?.logout_msg}
                                                            </h3>
                                                        </div>
                                                        {showSignInBtn && (
                                                        <div className="col-12 mb-4 mt-3">
                                                            <div className="d-grid">
                                                                <button type='button' className="d-grid btn btn-dark btn-lg button"
                                                                    onClick={handleClickLogin} >
                                                                    {logoutMsg?.logout_logout_signin_btn}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        )}
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
export default Logout;